import { type InvitedUserDto, type ReferralDto } from '@spin/shared';
import { useEffect, useState } from 'react';
import { http } from '../api/http';
import { Avatar, Spinner, useBackButton } from '../components/common';
import { reportError, useT } from '../i18n';
import { useSession } from '../store/session';
import { tg } from '../tg/bridge';
import { LanguagePills } from './Portal';

/** Invited users: who joined with my link, whether the invite reward is paid, and the link to share. */
export function Invited() {
  const t = useT();
  const back = useSession((s) => s.back);
  const [list, setList] = useState<InvitedUserDto[] | null>(null);
  const [ref, setRef] = useState<ReferralDto | null>(null);
  useBackButton(back);

  useEffect(() => {
    http.get<InvitedUserDto[]>('/referrals').then(setList).catch(reportError);
    http.get<ReferralDto>('/referral').then(setRef).catch(reportError);
  }, []);

  return (
    <div className="portal" data-testid="invited">
      <div className="portal-page">
        <LanguagePills />
        <div className="watch-bar">
          <button className="watch-back" onClick={back}>
            ← {t('common.back')}
          </button>
          <b>🎁 {t('portal.invited')}</b>
          <span />
        </div>
        {ref && (
          <div className="portal-card invite-box">
            <span>{t('invite.text', { bonus: ref.bonus })}</span>
            <button className="portal-btn green" onClick={() => tg.share(ref.link, t('invite.share_text'))}>
              {t('invite.share')}
            </button>
          </div>
        )}
        {!list ? (
          <Spinner />
        ) : list.length === 0 ? (
          <div className="portal-empty">{t('portal.invited_empty')}</div>
        ) : (
          <div className="invited-list">
            {list.map((u) => (
              <div key={u.id} className="portal-card invited-row">
                <Avatar name={u.displayName} photoUrl={u.photoUrl} size={36} />
                <span className="ellipsis">{u.displayName}</span>
                <small>{new Date(u.joinedAt).toLocaleDateString()}</small>
                <span className={u.rewarded ? 'reward done' : 'reward'}>
                  {u.rewarded ? `+❤${ref?.bonus ?? ''}` : '…'}
                </span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
